// Closes a popover/dropdown when the user clicks (or focuses) outside it.
// Shared by every menu (company switcher, agent footer, status dropdown) so the
// dismiss behavior stays identical everywhere.
import { useEffect, useRef } from "react";

export function useClickOutside<T extends HTMLElement>(active: boolean, onOutside: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!active) return;
    function handle(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) onOutside();
    }
    function handleKey(event: KeyboardEvent) {
      if (event.key === "Escape") onOutside();
    }
    document.addEventListener("mousedown", handle);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handle);
      document.removeEventListener("keydown", handleKey);
    };
  }, [active, onOutside]);

  return ref;
}
